import { createFileRoute } from '@tanstack/react-router'
import { getQueryOptions } from '~/services'
import z from 'zod'
import { Table } from '~/features/tables/components/Table'

const DEFAULT_LIMIT = 50
const DEFAULT_OFFSET = 0

const searchParamsSchema = z.object({
  filter: z.record(z.any()).optional(),
  limit: z
    .number()
    .positive()
    .default(DEFAULT_LIMIT)
    .catch(() => DEFAULT_LIMIT),
  group: z.record(z.any()).optional(),
  offset: z
    .number()
    .positive()
    .default(DEFAULT_OFFSET)
    .catch(() => DEFAULT_OFFSET),
  orderBy: z.string().optional(),
  orderDirection: z.enum(['asc', 'desc']).optional(),
  search: z.string().optional(),
})
export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/tables/$tableId')({
  component: Component,
  loaderDeps: ({ search }) => ({
    ...search,
    limit: search.limit ?? DEFAULT_LIMIT,
    offset: search.offset ?? DEFAULT_OFFSET,
  }),
  loader: ({ context, params, deps }) => {
    return Promise.all([
      context.queryClient.prefetchQuery(
        getQueryOptions(
          'workspaces_/$workspaceId_/bots_/$botId_/tables/$table_/rows/$filter/$limit/$group/$offset/$orderBy/$orderDirection/$search',
          {
            botId: params.botId,
            workspaceId: params.workspaceId,
            table: params.tableId,
            ...deps,
          }
        )
      ),
      context.queryClient.ensureQueryData(
        getQueryOptions('workspaces_/$workspaceId_/bots_/$botId_/tables/$table_', {
          botId: params.botId,
          workspaceId: params.workspaceId,
          table: params.tableId,
        })
      ),
    ])
  },

  validateSearch: searchParamsSchema,
})

function Component() {
  const { workspaceId, botId, tableId } = Route.useParams()
  const searchParams = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <Table
      params={{ workspaceId, botId, tableId }}
      searchParams={searchParams}
      onSearchParamsUpdated={(newSearchParams) => {
        navigate({ from: Route.fullPath, search: newSearchParams })
      }}
    />
  )
}
